var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconConnectionLost = function SvgIconConnectionLost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M46.633 17.367A19.965 19.965 0 0 0 12.9 25.2 12.92 12.92 0 0 0 2 38a13.075 13.075 0 0 0 11.11 12.89m8.375.11H52a11.045 11.045 0 0 0-.1-22 19.8 19.8 0 0 0-1.858-6.557M57 7 7 57"
  }))));
};
export { SvgIconConnectionLost as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGg2NHY2NEgweiIvPgogICAgICAgIDxnIHN0cm9rZT0iIzIyMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjQiPgogICAgICAgICAgICA8cGF0aCBkPSJNNDYuNjMzIDE3LjM2N0ExOS45NjUgMTkuOTY1IDAgMCAwIDEyLjkgMjUuMiAxMi45MjMgMTIuOTIzIDAgMCAwIDIgMzhhMTMuMDc1IDEzLjA3NSAwIDAgMCAxMS4xMSAxMi44OU0yMS40ODUgNTFINTJhMTEuMDQ1IDExLjA0NSAwIDAgMC0uMS0yMiAxOS43NDYgMTkuNzQ2IDAgMCAwLTEuODU4LTYuNTU3TTU3IDcgNyA1NyIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";